import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"
import tinymce from "tinymce"

// Se targetIdValue è un editor TinyMCE (es. "news_descrizione"), inserisce i
// marker [foto: id="..."] delle foto selezionate alla posizione del cursore.
// Altrimenti (es. un campo semplice come "fotogallery_cover_photo_id"),
// imposta il valore del campo con l'id della prima foto selezionata.
export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    targetId: String,
    selectAtLeastOne: String,
    editorNotFound: String
  }

  insert(event) {
    event.preventDefault()

    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked)

    if (checked.length === 0) {
      alert(this.selectAtLeastOneValue)
      return
    }

    const editor = tinymce.get(this.targetIdValue)

    if (editor) {
      const markers = checked.map((checkbox) => checkbox.dataset.marker)
      editor.focus()
      editor.selection.setContent(markers.join(" "))
      editor.save()
    } else {
      const field = document.getElementById(this.targetIdValue)
      if (!field) {
        alert(this.editorNotFoundValue)
        return
      }
      field.value = checked[0].value
      field.dispatchEvent(new Event("change", { bubbles: true }))
    }

    bootstrap.Modal.getInstance(this.element.closest(".modal"))?.hide()
  }
}
